module.exports = __webpack_public_path__ + "static/media/tenderbanner@2x.4e126494.png";